const RAW = process.env.REACT_APP_BACKEND_URL || "";
const BASE_URL = RAW.replace(/\/$/, "");

function assertBaseUrl() {
  if (!BASE_URL) throw new Error("REACT_APP_BACKEND_URL manquant");
}

export async function createShareLink({ tenantId, agentId, expiresInSec, maxUses }) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/integrations/shareLink`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, agentId, expiresIn: Number(expiresInSec || 0), maxUses: Number(maxUses || 0) }),
  });
  if (!r.ok) {
    let code = "";
    try { const j = await r.json(); code = j?.error || ""; } catch {}
    const err = new Error(`/integrations/shareLink failed (${r.status}) ${code}`);
    err.status = r.status; err.code = code; throw err;
  }
  return r.json(); // { url, token, jti, expiresAt }
}

export async function revokeShareLink({ tenantId, agentId, jti }) {
  assertBaseUrl();
  const r = await fetch(`${BASE_URL}/integrations/revokeShareLink`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ tenantId, agentId, jti }),
  });
  if (!r.ok) {
    let code = "";
    try { const j = await r.json(); code = j?.error || ""; } catch {}
    const err = new Error(`/integrations/revokeShareLink failed (${r.status}) ${code}`);
    err.status = r.status; err.code = code; throw err;
  }
  return r.json(); // { success: true }
}

